import {
  IOrderOperationsAnalytics,
  IOrderOperationsAnalyticsQuery,
  IStatistics,
} from "../../models/statistcs/respons";
import { IStatisticCachedPayload } from "../../models/statistcs/cache";
import { ICustomerSatisfactionStatisticQuery } from "../../models/customer-satisfaction/request";
import { ICustomerSatisfactionStatistic } from "../../models/customer-satisfaction/response";
import { HttpClient, RequestParams } from "../../utils/api/http-client";

class StatisticsService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  getAllStatistics = (params?: RequestParams) =>
    this.http.request<IStatistics>({
      path: `/general-statistic`,
      method: "GET",
      ...params,
    });

  getOrderOperationsAnalytics = (
    query?: IOrderOperationsAnalyticsQuery,
    params?: RequestParams,
  ) =>
    this.http.request<IOrderOperationsAnalytics & IStatisticCachedPayload>({
      path: `/general-statistic/order-operations-analytics`,
      method: "GET",
      query,
      ...params,
    });

  getCustomerSatisfaction = (
    query?: ICustomerSatisfactionStatisticQuery,
    params?: RequestParams,
  ) =>
    this.http.request<ICustomerSatisfactionStatistic & IStatisticCachedPayload>(
      {
        path: `/general-statistic/customer-satisfaction`,
        method: "GET",
        query,
        ...params,
      },
    );
}

export default StatisticsService;
